// TIP-518 — Testimonials / Proof section.
// Section copy locked from the handoff ("Proof, not promises."), populated
// with the app's existing real testimonial content (from
// components/public/Testimonials.jsx) rendered in the new card design.
import React from "react";

const TESTIMONIALS = [
  {
    quote:
      "Our financially stable, fully compliant business faced an inexplicable block on our credit insurance, hindering growth. For years, direct talks with underwriters yielded no results. The TREVEX team meticulously dissected our operations and financials, corrected erroneous information, and successfully negotiated the removal of the block while securing new credit limits. We're grateful and fully recommend TREVEX as a crucial business partner.",
    name: "IT Distributions Business",
    role: "Chief Financial Officer",
  },
  {
    quote:
      "At Credible X, our mission has always been to empower SMEs through accessible and innovative financial solutions. Our partnership with TREVEX has been a significant milestone in that journey. TREVEX brings a forward-thinking, collaborative approach to the fintech ecosystem, and working alongside their team has been seamless and strategically aligned. We're proud to collaborate with TREVEX in driving SME growth and advancing the future of embedded finance.",
    name: "Credible X",
    role: "CEO & Founder",
  },
  {
    quote:
      "TREVEX played a crucial role in helping us develop a robust credit policy and successfully navigate the complex trading landscape in the United Arab Emirates. We strongly endorse their services for businesses aiming to strengthen their payment terms and cultivate reliable relationships with both buyers and suppliers.",
    name: "Commodity Training Business",
    role: "Business Manager",
  },
];

const ProofSection = () => (
  <section data-component="Testimonials" className="section-dark">
    <div className="container-wide">
      <div className="sec-eyebrow"><span className="sec-eyebrow-dot" />Proof</div>
      <h2 className="sec-title-dark">Proof, not promises.</h2>
      <p className="sec-body-dark">
        Used by free zones, banks, federal authorities, and UAE businesses across every sector. Here is what they say.
      </p>

      <div className="proof-grid">
        {TESTIMONIALS.map((t) => (
          <article key={t.name} className="proof-card">
            <div className="proof-mark">&ldquo;</div>
            <p className="proof-body">{t.quote}</p>
            <div className="proof-attr">
              <b>{t.name}</b>, {t.role}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProofSection;
